import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { Skeleton } from 'ui/skeleton';
import { Body1Light } from '../Content.styles';
import { Wrapper, HeaderRow, Heading, Right, Description } from './MessageMediumCard.styles';
import {
  MESSAGE_MEDIUM_CARD_TEST_ID,
  createMessageMediumHeaderDescription,
} from './MessageMediumCard.constants';

export const MessageMediumCardLoading = ({
  messageMedium,
}: {
  messageMedium: SupportedMediums;
}) => (
  <Wrapper data-test={`${messageMedium}-${MESSAGE_MEDIUM_CARD_TEST_ID}`}>
    <HeaderRow>
      <Heading>{messageMedium} Frequency</Heading>
      <Description>
        <Body1Light>{createMessageMediumHeaderDescription(messageMedium)}</Body1Light>
      </Description>
      <Right>
        <Skeleton height={40} width={115} />
      </Right>
    </HeaderRow>
    <Skeleton height={56} />
  </Wrapper>
);
